module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "dropcap1"
  }, [_c('em', [_vm._v("C")])]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HAPTER 1")])]), _c('br'), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "chaptitle"
  }, [_c('em', [_vm._v("Dover, England"), _c('br'), _vm._v("June 20, 1822")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('em', [_vm._v("W")])]), _vm._v("illiam Hurst strode onto the "), _c('em', [_vm._v("Agile Witch")]), _vm._v(", the salty wind swirling his cape as he crossed the gangplank, his boots ringing with each step. He paused on the deck to look up at the rigging and gave a satisfied nod. Every brass hook and ring had been polished until they shone and every sail was freshly patched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Good. An idle crew was a troublesome crew, and he had no time for such nonsense. He hadn’t been captain for fifteen years without learning exactly how a ship should be run.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cap’n!” The first mate hurried over, saluting as he came to a halt. “Ye’re early.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aye.” William took another look about the ship. “She looks to be in fine fettle, MacDougal.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("His first mate beamed. “Och, so she is. I put Halpurn in charge whilst I purchased supplies. He did a fine job keepin’ the crew on task, except—” MacDougal hesitated. At William’s pointed look, he continued, “There was a minor lapse in the watch, but I’ve taken care o’ it. It won’t happen again.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Excellent.” William lifted his face to the breeze. “Plan on sailing with the morning tide—our mission is urgent. And give Lawton a copy of the manifest. We make this journey at my brother’s behest; he can damn well repay the expenses.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("MacDougal chuckled. “Aye, Cap’n. Consider it done.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William headed belowdecks. Michael had gotten himself into quite a mess, all for the object now resting in William’s coat pocket.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Entering his cabin, William removed the ancient Egyptian artifact from his pocket and placed it on his desk. Then he withdrew a chain from his neck and used the small golden key hanging on it to open the desk. He set the artifact inside and locked it away. It was a relief to have that damned thing under lock and key. His sister Mary had gone through hell getting her hands upon it, and now it was up to him to deliver it to the sulfi who held their brother prisoner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Soon,” he murmured to the far-away Michael.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("William returned the chain to his neck and tucked it out of sight before reaching for his map ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("case. His fingers had just closed on the stiff leather tube when he caught a faint whiff of the purest essence of lily.")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The scent made him freeze in place, held there by a scrap of memory he thought he’d forgotten years ago. A memory of exotic violet eyes fringed with thick, black lashes; of hair that slid through his greedy fingers like black silk; of creamy skin that held the sun’s fragrant kiss; and of a lush mouth, ripe for kisses that—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hello, William.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The throaty voice yanked him from the memory. He closed his eyes, his hand still on the map case. Her voice possessed an unusual quality, a throaty resonance that made even a whisper clear. It was rich and low for a woman, feminine and wanton.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William knew the voice as well as his own. And it was the last voice he expected to hear inside his cabin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Aren’t you going to return my greeting? Or are we still not speaking?” The lilting voice ran up and down his spine, as sensual as a warm hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gritted his teeth against his traitorous body and released the map tube before turning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sitting in a chair at the head of the captain’s table was the one woman he’d never wanted to see again. The woman whose gut-wrenching betrayal had left him hollow, causing him to set sail and keep from England’s shores for more than two years.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("He’d vowed to never, ever trust another ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("woman … especially this one. And he’d vowed to never trust her again—he’d promised himself he’d never again lay eyes upon her.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet here she was, sitting in his cabin, the fading sunlight caressing her creamy skin and limning her graceful neck. Her black cloak was tossed over the back of her chair, revealing a red gown as wanton as her nature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her gown was a perfect foil for her upswept black hair, the thin white ruffle at her décolletage pretending a modesty that was betrayed by the full breasts swelling above it. She was a master at looking innocent and wanton at the same time. It used to make him crazed for her. Fortunately, he now recognized artifice when he saw it, and it was written all over her beautiful face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He removed his own cloak, turning away from her to break the spell of her beauty. As he hung the cloak on a brass hook by the door, he took a deep breath. Without turning he said, “Get out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not even going to ask why I’m here?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t care why you’re here. Just leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A faint rustling told him she’d stood. “William, I must talk to you. I hoped you weren’t still upset about us—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There was no ‘us.’ We were an illusion.” He finally turned to face her, his icy gaze pinning her in place. “That’s "), _c('em', [_vm._v("all")]), _vm._v(" we were and you know it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("She flushed, her skin pinkening as if he’d slapped her. “I’m sorry. I was wrong to have acted as I did and—”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Leave.” He had to grit his teeth. There was something about her that was simply breathtaking, mesmerizing, that made it almost impossible not to watch her. "), _c('em', [_vm._v("Damn it, I should be over this! It’s been years")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her hands fisted at her sides and she sank back into her chair. “I can’t go. I came all the way here and I—” Her voice broke. “William, I am desperate.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Any other man would have been moved by her tears, but he ignored the obvious manipulation. “Find another fool, Marcail. This one isn’t available.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She gripped the arms of her chair. “You "), _c('em', [_vm._v("must")]), _vm._v(" hear me out, William. No one else can help.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about your lover? Or has Colchester finally come to his senses and ended his protection?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her lips thinned. “Of course not. But this is a private matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Private? Or ‘secret?’ Those are two very different words.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s both. I can’t share this with Colchester.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t you trust him?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, but this could cause a scandal and I don’t want him—or anyone else—hurt.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William examined her a moment. “Ah. You don’t think Colchester "), _c('em', [_vm._v("can")]), _vm._v(" help you.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Her cheeks stained a deeper pink. “Whatever ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("you say about Colchester, he has helped me in ways no one else would.”")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“If by ‘helped’ you mean ‘gave large sums of money,’ I’m certain that’s true. The earl is a wealthy man.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She shrugged indifferently, but her expression was strained and he took pleasure in knowing he was pushing the limits of her considerable acting skills.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was how she earned her living, by treading upon the boards of Drury Lane. Marcail Beauchamp was beautiful, accomplished, and reportedly the finest actress England had ever produced.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His gaze flickered over her, noting that her elegant gown was a trifle too revealing for true modesty. "), _c('em', [_vm._v("And that is the")]), _vm._v(" other "), _c('em', [_vm._v("way she makes her living")]), _vm._v(", he reminded himself harshly. "), _c('em', [_vm._v("She gives herself to the highest bidder")]), _vm._v(". “Colchester can have you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“William, please. Can’t you put the past behind you long enough to hear me out? I—” She hesitated and he saw a flicker of uncertainty. But was it real? “William, I came to ask a favor.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave a bitter laugh. “No.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t even know what I’m asking.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("“I don’t need to. If it has to do with you, I want nothing of it.” "), _c('em', [_vm._v("What was I thinking, to believe the words of an actress? I was besotted. Wildly, crazily, stupidly besotted")]), _vm._v(". He was older now, and knew her measure. His gaze flickered across her and he realized that she was just ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("as beautiful as before, curse it—perhaps even more so. Her beauty had ripened, as had her body. Gone was her slender, almost coltish beauty; in its place was a seductive, mature woman who moved with an assurance that couldn’t be faked.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please, William, this is important. And this is not easy for me, either.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He smiled coldly. “I don’t care if this is easy for you.” He pulled out a chair and dropped into it. “How did you get in here? The crew didn’t alert me that I had a guest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I came onboard before it was light.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is always a guard by the gangway.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He was asleep.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Ah. The watch lapse MacDougal mentioned")]), _vm._v(". “I sense some trickery here. I know you, Marcail Beauchamp, and you cannot be trusted.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t know me. You never did.” She spoke with such quiet dignity that he was almost taken aback. And oddly unwilling to toss her out just yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He leaned back in his chair and crossed his arms over his chest. He could easily pick her up and throw her from his cabin, but he was loathe to touch her, unwilling to awaken memories that could be dredged back to the surface if his skin touched hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some things were better left unexamined.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("She stood as if restless, her lush figure on display ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("as she crossed to the port window. “So have I wasted my time in coming here?”")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("His jaw tightened. “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I see.” Her gaze fell to the floor and she bit her lip. Finally, she sighed and gestured gracefully toward the decanter and glasses on his sideboard. “Shall we at least drink to our brief reunion?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll drink to our final parting,” he shot back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Opening the decanter, she tossed him a rueful smile over her shoulder. “Still the same no-nonsense William, I see.” She lifted the decanter and took a delicate sniff. “A very nice port.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” he said shortly, watching as she poured out two glasses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You didn’t use to be so discerning in your choice of drink,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m far more discerning in "), _c('em', [_vm._v("all")]), _vm._v(" of my pleasures now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her lips thinned, but she merely held one glass up to regard the color. “"), _c('em', [_vm._v("Very")]), _vm._v(" impressive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s from Napoleon’s private supply.” William wasn’t sure why he felt the need to mention that, but he had.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I shall enjoy it all the more then.” She replaced the stopper on the decanter and brought him a glass, then carried her own back to her seat. She sat and delicately swirled the liquid. “Is there any way to convince you to change your mind? If I told you what I need, you might reconsider.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“If there’s one thing you taught me, it’s to never trust an answer that’s actually another question.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She paused from taking a sip. “I taught you that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, you taught me all sorts of things—none of them good.” He took a deep drink of the port, the sharpness clearing his throat. “Enough of this. I have work to do; you have two minutes to tell me why you are here.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her gaze narrowed and she pushed her glass away. “Fine. I came here because someone is blackmailing me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What does that have to do with me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Anger flashed across her face, so swift that he believed it real. “William, I am "), _c('em', [_vm._v("desperate")]), _vm._v(". I don’t know who is doing it or why, but it must stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But you "), _c('em', [_vm._v("do")]), _vm._v(" know what information they hold over your head. Information you don’t wish Colchester to know.” William watched her closed expression as he drained his glass. “Did you stray, Marcail? Is that the secret? That you can no more be true to a man than a dog can stop himself from chasing a squirrel?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her eyes flashed fire. “It’s nothing so tawdry, damn it! If my secret were revealed it wouldn’t be I who would pay, but others.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('em', [_vm._v("What")]), _vm._v(" others?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Their names don’t matter.” She folded her lips firmly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("“I am done with secrets and lies. I think you should go.” William pushed his empty glass away, suddenly tired of it all. Tired by the deceptions that had left him so beaten all those years ago.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A regretful smile curved one side of her lovely mouth. “Ah, William. Life never gave us a chance, did it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("What in hell did that mean?")]), _vm._v(" “Just go, Marcail.” His mouth felt dry, and he wished his glass wasn’t empty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcail rose and came toward him. “Oh, I shall leave. But not until you’ve helped me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Damn you, I’ve already said I won’t—won’t help.” Why was he slurring his words?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked at his fingers, cupped loosely around his empty glass. "), _c('em', [_vm._v("I can’t feel my hand")]), _vm._v(". The thought floated through his mind with an odd detachment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But he’d had only one glass. It took far more than that to—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked up at Marcail to say, “You put something in my drink,” but his mouth wouldn’t form the words. His vision suddenly blurred, and a wave of weakness crashed through him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("No")]), _vm._v(". He gathered every ounce of his strength and forced his numb arms to push him to his feet, where he swayed dangerously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She frowned. “William, don’t! You’ll hurt yourself—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He toppled forward. "), _c('em', [_vm._v("Damn. She’s poisoned me")]), _vm._v(".")])]), _c('div', {
    staticClass: "pagebreak"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "noindentb"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('em', [_vm._v("A letter from Michael Hurst to his brother William, describing his first sight of Athens")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Upon arriving in this ancient metropolis, I felt as if I were perched upon the precipice of potential. This feeling was so powerful, I thought I had a fever. It is surprising how many times a good feeling can be confused with a bad one. Often one is unsure which feeling it really is until much later.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f7044d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 87
// module chunks = 0